import { Banner, BannerTile } from '@cinemark/content-api-client';
import { BannerImageComponent } from './banner-image';
import { BannerTextComponent } from './banner-text';

type BannerProps = {
  banner: Banner | BannerTile;
  className?: string;
  dataLinkCategory: string;
  dataLinkNamePrefix?: string;
  imageClassName?: string;
};

export const BannerComponent = ({ banner, className, dataLinkCategory, dataLinkNamePrefix, imageClassName }: BannerProps): React.JSX.Element | null => {
  if (!banner) return null;

  const hasImage = !!(banner.bannerImageLarge?.url || banner.bannerImageMedium?.url || banner.bannerImageSmall?.url);

  if (hasImage) {
    return (
      <BannerImageComponent banner={banner}
        className={className}
        imageClassName={imageClassName}
      />
    );
  }

  return (
    <BannerTextComponent banner={banner}
      className={className}
      dataLinkCategory={dataLinkCategory}
      dataLinkNamePrefix={dataLinkNamePrefix}
    />
  );
};
